exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face{font-family:RobotMedium;src:url(" + require("./Roboto-Regular.ttf") + ")}*{font-family:RobotMedium}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/components/index_home.css
// module id = 377
// module chunks = 0